import { Record } from './record';

export interface HistoryUser {
  items: HistoryItem[];
  lastPage: boolean;
}

export interface HistoryItem {
  recordId: string;
  type: HistoryItemType;
  start: Date;
  end: Date;
  percentage?: number;
  ebookTimeReading?: string;
  mediaId: string;
  record?: Record;
  urlCertificate: string;
  learningExperience: boolean;
  deletable: boolean;
  format: string;
  parentRecordId: string | null;
  completed: boolean | null;
}

export enum HistoryItemType {
  PRESTAMO_HISTORICO = 'PRESTAMO_HISTORICO',
  VISUALIZATION = 'VISUALIZATION',
  PRESTAMO_REMOTO = 'PRESTAMO_REMOTO',
  PHYSICAL_CHECKOUT = 'PRESTAMO_FISICO',
}
